import { fetchNotifications } from "./asyncThunks";

export const fetchNotificationsBuilder = (builder) => {
  builder.addCase(fetchNotifications.fulfilled, (state, action) => {
    state.notifications.data = action.payload;
  });
};
